module.exports = __webpack_public_path__ + "static/media/krx-public-03.91cd5f6d.jpg";